
import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/RedboxRisk.css';

const RedboxRisk = () => {
  return (
    <>
      <Helmet>
        <title>Redbox Risk - Risk Management & Financial Controls | Redbox Global</title>
        <meta
          name="description"
          content="Redbox Risk provides advanced risk management, exposure monitoring, stress testing, and compliance tools for financial institutions."
        />
        <meta
          name="keywords"
          content="Redbox Risk, risk management, financial risk, market risk, credit risk, compliance, stress testing"
        />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/risk" />
        <meta property="og:title" content="Redbox Risk - Risk Management Platform" />
        <meta
          property="og:description"
          content="Monitor exposure, manage risk, and ensure compliance with Redbox Risk."
        />
        <meta
          property="og:image"
          content="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200&h=630&fit=crop"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Redbox Risk - Risk Management Platform" />
        <meta
          name="twitter:description"
          content="Professional-grade risk management and compliance tools."
        />
        <meta
          name="twitter:image"
          content="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200&h=630&fit=crop"
        />

        <link rel="canonical" href="https://redboxglobal.com/risk" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "Redbox Risk",
            "applicationCategory": "FinanceApplication",
            "operatingSystem": "Web",
            "description":
              "Risk management platform for monitoring exposure, stress testing, and regulatory compliance.",
            "url": "https://redboxglobal.com/risk",
            "publisher": {
              "@type": "Organization",
              "name": "Redbox Global"
            }
          })}
        </script>
      </Helmet>

      <div className="page-container">
        <div className="page-header">
          <h1>Redbox Risk</h1>
          <p className="page-subtitle">
            Intelligent risk management, controls, and compliance for modern markets
          </p>
        </div>

        <div className="page-content">
          {/* Featured Article */}
          <a
            href="/article/redbox-risk-overview"
            style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
          >
            <div className="featured-article">
              <div className="featured-image">
                <img
                  src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200&h=600&fit=crop"
                  alt="Risk management dashboard"
                />
              </div>
              <div className="featured-content">
                {/* <span className="article-category">Risk Platform</span> */}
                <h2>Proactive Risk Management Across Global Markets</h2>
                <p>
                  Redbox Risk delivers real-time exposure monitoring, stress testing, and
                  compliance insights across asset classes, helping firms manage uncertainty
                  and protect capital.
                </p>
                <span className="article-meta">Explore Risk</span>
              </div>
            </div>
          </a>

          {/* Article Cards */}
          <div className="content-grid">
            <a
              href="/article/market-risk"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop"
                    alt="Market risk analysis"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Market Risk</span> */}
                  <h2>Real-Time Market Risk & Exposure Monitoring</h2>
                  <p>
                    Track portfolio exposure and sensitivities in real time with advanced
                    market risk analytics.
                  </p>
                  <span className="article-meta">Monitor Risk</span>
                </div>
              </article>
            </a>

            <a
              href="/article/stress-testing"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=600&h=400&fit=crop"
                    alt="Stress testing scenarios"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Stress Testing</span> */}
                  <h2>Scenario Analysis & Stress Testing</h2>
                  <p>
                    Simulate market events and assess portfolio resilience under extreme
                    conditions.
                  </p>
                  <span className="article-meta">Run Scenarios</span>
                </div>
              </article>
            </a>

            <a
              href="/article/regulatory-compliance"
              style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
            >
              <article className="article-card">
                <div className="article-image">
                  <img
                    src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=600&h=400&fit=crop"
                    alt="Regulatory compliance"
                  />
                </div>
                <div className="article-content">
                  {/* <span className="article-category">Compliance</span> */}
                  <h2>Regulatory Compliance & Reporting</h2>
                  <p>
                    Stay compliant with global regulations using automated reporting and
                    governance tools.
                  </p>
                  <span className="article-meta">Ensure Compliance</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default RedboxRisk;
